// ** Redux Imports
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { decodeBytes32String, formatUnits } from "ethers";

export const functionName = createAsyncThunk(
  "functionName",
  async ({ dispatch, unSignerVars }) => {
    let error = null;

    return { result: null || null, error };
  }
);

export const getIsClaimed = createAsyncThunk(
  "getIsClaimed",
  async ({ dispatch, unSignerVars, poolId, address }) => {
    let error = null;

    const isClaimed = await unSignerVars.contract.isClaimed(poolId, address);

    return { result: Boolean(isClaimed), error };
  }
);

//_isPrizesShared
export const getIsDrawn = createAsyncThunk(
  "getIsDrawn",
  async ({ dispatch, unSignerVars, poolId }) => {
    let error = null;

    const isDraw = (await unSignerVars.contract.poolPrizes(poolId, 0)).isDrawn;

    return { result: Boolean(isDraw), error };
  }
);

export const getInfo = createAsyncThunk(
  "getInfo",
  async ({ dispatch, unSignerVars, poolId, address }) => {
    let error = null;

    const getInfo = await unSignerVars.contract.getInfo(
      poolId,
      address || "0x0000000000000000000000000000000000000000"
    );

    const prizeShareCount = Number(getInfo.prizeShareCount);
    const userTicketCount = Number(getInfo.userTicketCount);
    const userJoinedPoolCount = Number(getInfo.userJoinedPoolCount);
    const ticketCount = Number(getInfo.ticketCount);
    const assignTicketCount = Number(getInfo.assignTicketCount);
    const refCodesCount = Number(getInfo.refCodesCount);
    const prizeSeedsCount = Number(getInfo.prizeSeedsCount);
    const maxTicketCount = Number(getInfo.maxTicketCount);

    const info = {
      prizeShareCount,
      userTicketCount,
      userJoinedPoolCount,
      ticketCount,
      assignTicketCount,
      refCodesCount,
      prizeSeedsCount,
      maxTicketCount,
    };

    return { result: info, error };
  }
);

export const getPrizes = createAsyncThunk(
  "getPrizes",
  async ({ dispatch, unSignerVars, poolId, prizeShareCount }) => {
    let error = null;
    let prizes = [];

    if (prizeShareCount > 0) {
      for (let i = 0; i < prizeShareCount; i++) {
        const poolPrizes = await unSignerVars.contract.poolPrizes(poolId, i);

        prizes.push({
          prizeIndex: i,
          isDrawn: poolPrizes.isDrawn,
          share: Number(poolPrizes.share),
        });
      }
    } else {
      prizes = null;
    }

    return { result: prizes, error };
  }
);

const calculatePrizeAmount = (
  _totalPrizeToken,
  _lpwc,
  _prizes,
  _wonPrizeIndex,
  _PRECISION_BASIS
) => {
  const prizeAmount =
    (_totalPrizeToken * _prizes[_wonPrizeIndex].share) / _PRECISION_BASIS;
  if (_wonPrizeIndex != _prizes.length - 1) {
    return prizeAmount;
  } else {
    return Number(prizeAmount) / _lpwc;
  }
};

export const getTickets = createAsyncThunk(
  "getTickets",
  async ({ dispatch, unSignerVars, poolId, address, userTicketCount, decimals }) => {
    //TODO: event sonrası update için iyileştirme yapılacak
    let error = null;
    let tickets = [];
    let prizes = null;
    let totalPrizeToken = null;
    let lpwc = null;
    let PRECISION_BASIS = null;

    const status = Number(await unSignerVars.contract.getStatus(poolId));
    if (status >= 4) {
      totalPrizeToken = Number(
        formatUnits(await unSignerVars.contract.totalPrizeToken(poolId), decimals)
      );
      lpwc = Number(await unSignerVars.contract.lastPrizeWinnerCount(poolId));
      PRECISION_BASIS = Number(await unSignerVars.contract.PRECISION_BASIS());
      const info = await dispatch(getInfo({ unSignerVars, poolId }))
        .then((result) => {
          if (result.payload.result) {
            return result.payload.result;
          }
        })
        .catch((error) => console.error(error));
      prizes = await dispatch(
        getPrizes({
          unSignerVars,
          poolId,
          prizeShareCount: info.prizeShareCount,
        })
      )
        .then(async (result) => {
          if (result.payload.result) {
            return result.payload.result;
          }
        })
        .catch((error) => console.error(error));
    }
    console.log("getPrizes:", prizes);

    for (let i = 0; i < Number(userTicketCount); i++) {
      const ticket = await unSignerVars.contract.userTickets(
        poolId,
        address,
        i
      );
      tickets.push({
        ticketNumber: Number(ticket.ticketNumber),
        wonPrizeIndex: Number(ticket.wonPrizeIndex),
        wonPrizeAmount: Boolean(ticket.isWon)
          ? calculatePrizeAmount(
              totalPrizeToken,
              lpwc,
              prizes,
              Number(ticket.wonPrizeIndex),
              PRECISION_BASIS
            )
          : 0,
        isWon: Boolean(ticket.isWon),
        usedRefCode: decodeBytes32String(ticket.usedRefCode),
      });
    }

    // cache
    // sessionStorage.setItem(
    //   `tickets-${address}-${poolId}`,
    //   JSON.stringify(tickets)
    // );

    return { result: tickets, error };
  }
);

export const homeStore = createSlice({
  name: "homeStore",
  initialState: {},
  reducers: {},
});

export default homeStore.reducer;
